module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/personality-relax-shenzhen.c7b5077c.png";